import { PaneArea } from '../../../types/shared'
import RotatedRectangleV1, { IRotatedRectangleV1Attrs } from '../../canvas/rotated_rectangle/rotated_rectangle_v1'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IRotatedRectangleV1Attrs
type PartialAttrs = Partial<Attrs>

const TOTAL_ROTATED_RECTANGLE_POINTS_COUNT = 3
class RotatedRectangleV1Creator extends RotatedRectangleV1<Attrs> {
  rotatedRectanglePoints = 1
  lastY = 0
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = this.attrs.x2 = startArea.x
    this.attrs.y1 = this.attrs.y2 = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  setIsSelected(isSelected: boolean) {
    super.setIsSelected(isSelected)
    // setIsSelected can be called while drawing creator is active, but the click is made outside of the drawing bounderies
    // so we need to call "set" method manually to "finish" the drawing
    this.set({})
  }

  set(obj: PartialAttrs) {
    super.set(obj)
    if (!this.isSelected && this.rotatedRectanglePoints === TOTAL_ROTATED_RECTANGLE_POINTS_COUNT - 1) {
      this.rotatedRectanglePoints += 1
      this.release()
      setTimeout(() => {
        this.replaceMyself(RotatedRectangleV1.fromObject<RotatedRectangleV1>(this.attrs, this.model))
        this.toolsCallback()
      }, 0)
    }
    return this
  }

  onMouseDown() {
    this.rotatedRectanglePoints++
    if (this.rotatedRectanglePoints === TOTAL_ROTATED_RECTANGLE_POINTS_COUNT) {
      this.release()
      this.replaceMyself(RotatedRectangleV1.fromObject<RotatedRectangleV1>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    switch (this.rotatedRectanglePoints) {
      case 1:
        this.attrs = {
          ...this.attrs,
          x2: area.x,
          y2: area.y,
        }
        break
      case 2:
        this.attrs = {
          ...this.attrs,
          cursorTargetX: area.x,
          cursorTargetY: area.y,
        }
        break
      default:
        break
    }
    this.lastY = area.y
    this.trigger('change')
  }
}

export default RotatedRectangleV1Creator
